import { ComponentProps, FC, ReactNode } from 'react';
import type { ButtonProps } from 'antd';
import { Button } from 'antd';

import DropdownButtonIcon from './DropdownButtonIcon';

export interface DropdownButtonProps extends Omit<ButtonProps, 'children'> {
    children: ReactNode;
    directionIconProps?: ComponentProps<typeof DropdownButtonIcon>;
    trailingIcon?: ReactNode;
}

const DropdownButton: FC<DropdownButtonProps> = ({
    block,
    children,
    danger,
    directionIconProps,
    style,
    trailingIcon,
    type,
    ...buttonProps
}) => (
    <Button
        {...buttonProps}
        block={block}
        danger={danger}
        type={type}
        style={{ alignItems: 'center', display: 'inline-flex', justifyContent: 'center', ...style, boxShadow: 'none' }}
    >
        <span
            style={{
                alignItems: 'center',
                display: 'inline-flex',
                flex: block ? '1 1 auto' : undefined,
                gap: 'inherit',
                minWidth: 0,
                overflow: 'hidden',
            }}
        >
            {children}
        </span>
        {trailingIcon === undefined ? (
            <DropdownButtonIcon
                {...directionIconProps}
                buttonType={type}
                style={{
                    flex: 'none',
                    ...directionIconProps?.style,
                }}
            />
        ) : trailingIcon !== null ? (
            <span style={{ alignItems: 'center', display: 'inline-flex', flex: 'none' }}>{trailingIcon}</span>
        ) : null}
    </Button>
);

export { DropdownButtonIcon };
export default DropdownButton;
